import { Injectable } from '@angular/core';
import { HeaderType } from '../enums/enums';
import { CustomerFilter } from '../interface/interface';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  constructor(private readonly http: HttpService) {}

  fetchCustomers(filter: CustomerFilter) {
    filter.paymentStatus;
    return this.http.get(`api/admin/customers`, {
      params: {
        headerType: HeaderType.ACCESS,
        search: filter.searchText,
        page: filter.pageNumber,
        limit: filter.limit,
        ...(filter.startDate ? { startDate: filter.startDate } : {}),
        ...(filter.endDate ? { endDate: filter.endDate } : {}),
        paymentStatus: filter.paymentStatus,
      },
    });
  }

  fetchCustomerDetails(ownerId: string) {
    return this.http.get(`api/admin/customers/${ownerId}/profile`, {
      params: {
        headerType: HeaderType.ACCESS,
      },
    });
  }
}
